import { API_URL } from '../config';

// Helper to ensure HTTP for localhost URLs
const ensureHttp = (url) => {
  if (url.includes('localhost')) {
    return url.replace(/^https:\/\//i, 'http://');
  }
  return url;
};

// Custom fetch wrapper that ensures HTTP for localhost
export const apiFetch = async (endpoint, options = {}) => {
  const url = endpoint.startsWith('http') ? endpoint : `${API_URL}${endpoint}`;

  // Force HTTP for localhost URLs
  const finalUrl = url.includes('localhost') ? url.replace('https://', 'http://') : url;

  const response = await fetch(finalUrl, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

// Helper function to get auth headers
export const getAuthHeaders = async (getAccessTokenSilently) => {
  try {
    const token = await getAccessTokenSilently({
      authorizationParams: {
        audience: "retro-api",
        scope: "openid profile email read:images write:images"
      }
    });
    return {
      Authorization: `Bearer ${token}`
    };
  } catch (error) {
    console.error('[RETRO-API] ❌ Failed to get auth headers:', error);
    throw error;
  }
}; 